// src/Dashboard.js - Beautiful Red/Green Calculator Selection
import React from 'react';
import { useUser} from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Dashboard() {
  const { user } = useUser();
  const navigate = useNavigate();

  const handleSPVClick = () => {
    navigate('/spv');
  };

  const handleIndividualClick = () => {
    navigate('/individual');
  };

  return (
    <div className="dashboard-container">
      {/* Logo in Top Left */}
      <div style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        zIndex: 100
      }}>
        <svg 
          viewBox="0 0 360 90" 
          xmlns="http://www.w3.org/2000/svg"
          style={{ 
            width: '250px', 
            height: '62.5px',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/')}
        >
          <defs>
            <linearGradient id="brandBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor:'#157DEC', stopOpacity:1}} />
              <stop offset="100%" style={{stopColor:'#1054a8', stopOpacity:1}} />
            </linearGradient>
            <linearGradient id="accentBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor:'#1054a8', stopOpacity:1}} />
              <stop offset="100%" style={{stopColor:'#0c4389', stopOpacity:1}} />
            </linearGradient>
            <linearGradient id="lightBlue" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor:'#3b94f0', stopOpacity:1}} />
              <stop offset="100%" style={{stopColor:'#157DEC', stopOpacity:1}} />
            </linearGradient>
            
            <filter id="energyGlow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
              <feMerge> 
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
            
            <filter id="sharpShadow" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="3" dy="3" stdDeviation="0" floodColor="rgba(0,0,0,0.25)"/>
            </filter>
          </defs>
          
          <path d="M 15 15 L 65 25 L 55 65 L 25 55 Z" fill="url(#brandBlue)" opacity="0.08" transform="rotate(12 40 40)"/>
          <circle cx="50" cy="50" r="25" fill="url(#lightBlue)" opacity="0.05"/>
          
          <g transform="translate(20, 22) skewX(-8)" filter="url(#sharpShadow)">
            <rect x="6" y="16" width="26" height="20" fill="url(#brandBlue)" rx="3"/>
            <path d="M 19 6 L 4 16 L 34 16 Z" fill="url(#accentBlue)"/>
            <rect x="12" y="26" width="7" height="10" fill="#ffffff" rx="2"/>
            <circle cx="17" cy="31" r="1.2" fill="url(#lightBlue)"/>
            <rect x="22" y="20" width="7" height="5" fill="#ffffff" rx="1"/>
            <rect x="8" y="20" width="4" height="4" fill="#ffffff" rx="1"/>
            <path d="M 19 8 L 15 12 L 23 12 Z" fill="#ffffff" opacity="0.9"/>
          </g>
          
          <g transform="translate(50, 28) skewX(5)" filter="url(#energyGlow)">
            <rect x="0" y="0" width="20" height="26" fill="url(#lightBlue)" rx="4"/>
            <rect x="2" y="2" width="16" height="7" fill="#000000" rx="2"/>
            <text x="10" y="7" textAnchor="middle" fill="#157DEC" fontFamily="JetBrains Mono, monospace" fontSize="3.5" fontWeight="700">+18.2%</text>
            
            <g fill="#ffffff">
              <rect x="3" y="11" width="3" height="2.5" rx="0.5"/>
              <rect x="7" y="11" width="3" height="2.5" rx="0.5"/>
              <rect x="11" y="11" width="3" height="2.5" rx="0.5"/>
              <rect x="15" y="11" width="3" height="2.5" rx="0.5" fill="url(#accentBlue)"/>
              
              <rect x="3" y="14.5" width="3" height="2.5" rx="0.5"/>
              <rect x="7" y="14.5" width="3" height="2.5" rx="0.5"/>
              <rect x="11" y="14.5" width="3" height="2.5" rx="0.5"/>
              <rect x="15" y="14.5" width="3" height="2.5" rx="0.5" fill="url(#accentBlue)"/>
              
              <rect x="3" y="18" width="3" height="2.5" rx="0.5"/>
              <rect x="7" y="18" width="3" height="2.5" rx="0.5"/>
              <rect x="11" y="18" width="3" height="2.5" rx="0.5"/>
              <rect x="15" y="18" width="3" height="5" rx="0.5" fill="url(#brandBlue)"/>
              
              <rect x="3" y="21.5" width="7" height="2.5" rx="0.5"/>
              <rect x="11" y="21.5" width="3" height="2.5" rx="0.5"/>
            </g>
            
            <circle cx="17" cy="3.5" r="1" fill="url(#brandBlue)" opacity="0.9"/>
          </g>
          
          <g transform="translate(-5, 0)">
            <g transform="translate(95, 0)">
              <text x="0" y="22" fontFamily="Poppins, system-ui, sans-serif" fontSize="20" fontWeight="800" fill="#ffffff">
                <tspan fill="#ffffff">The Buy</tspan><tspan fill="#ffffff"> to </tspan><tspan fill="#ffffff">Let</tspan>
              </text>
              <text x="0" y="44" fontFamily="Poppins, system-ui, sans-serif" fontSize="20" fontWeight="800" fill="#ffffff">
                Calculator <tspan fill="#ffffff">Company</tspan>
              </text>
              
              <text x="0" y="63" fontFamily="Inter, system-ui, sans-serif" fontSize="9" fontWeight="500" fontStyle="italic" fill="#ffffff" letterSpacing="0.5px">
                Affordability Guidance for Brokers
              </text>
              
              <rect x="0" y="68" width="60" height="2" fill="#ffffff" rx="1" opacity="0.7"/>
            </g>
          </g>
          
          <g opacity="0.6">
            <path d="M 320 20 L 330 15 L 340 25 L 325 30 Z" fill="url(#accentBlue)"/>
            <circle cx="315" cy="60" r="4" fill="url(#lightBlue)"/>
            <rect x="330" y="70" width="8" height="8" fill="url(#brandBlue)" rx="2" transform="rotate(25 334 74)"/>
          </g>
          
          <path d="M 280 30 Q 290 25 300 30" stroke="url(#brandBlue)" strokeWidth="1.5" fill="none" opacity="0.4"/>
          <path d="M 285 65 Q 295 60 305 65" stroke="url(#accentBlue)" strokeWidth="1" fill="none" opacity="0.5"/>
        </svg>
      </div>

      {/* Header with User Button */}
      <div className="dashboard-header">
        <h1>BTL Calculator Suite</h1>
        <p>Welcome back, {user?.firstName || 'Professional'}! Choose your calculator type below</p>
              </div>

      {/* Calculator Options */}
      <div className="calculator-options">
        <div 
          className="calculator-card spv-card"
          onClick={handleSPVClick}
          style={{ cursor: 'pointer' }}
        >
          <div className="card-header">
            <h2>Limited Company (SPV)</h2>
          </div>
          <div className="card-content">
            <p>For Special Purpose Vehicle buy-to-let calculations including corporate tax considerations and SPV-specific lending criteria.</p>
            <ul>
              <li>Corporate tax rates</li>
              <li>SPV lending criteria</li>
              <li>Limited company structure</li>
              <li>Professional landlord rates</li>
            </ul>
          </div>
          <button 
            className="calculator-button spv-button"
            onClick={(e) => {
              e.stopPropagation(); // Prevent double-click when clicking button
              handleSPVClick();
            }}
          >
            Start SPV Calculator
          </button>
        </div>

        <div 
          className="calculator-card individual-card"
          onClick={handleIndividualClick}
          style={{ cursor: 'pointer' }}
        >
          <div className="card-header">
            <h2>Individual (BRT/HRT)</h2>
          </div>
          <div className="card-content">
            <p>For Individual buy-to-let calculations including basic rate and higher rate tax considerations for personal ownership.</p>
            <ul>
              <li>Basic Rate Tax (BRT)</li>
              <li>Higher Rate Tax (HRT)</li>
              <li>Individual ownership</li>
              <li>Personal tax implications</li>
            </ul>
          </div>
          <button 
            className="calculator-button individual-button"
            onClick={(e) => {
              e.stopPropagation(); // Prevent double-click when clicking button
              handleIndividualClick();
            }}
          >
            Start Individual Calculator
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="dashboard-footer">
        © The BTL Calculator Company Ltd. All Rights Reserved 2025
        <br />
        Not for public use. For professional intermediaries use only.
      </div>
    </div>
  );
}

export default Dashboard;